import get from 'lodash/get';
import isArray from 'lodash/isArray';

export const createErrorMessage = (t, fallback, params) => action => {
  let errorMessage = '';

  const cause = get(action, 'reason.cause');

  if (isArray(cause)) {
    errorMessage = cause.map(c => (c.errors || []).join(' ')).join(' ');
  } else {
    errorMessage = get(cause, 'error.message');
  }

  return typeof errorMessage === 'string' && errorMessage?.includes(' ')
    ? errorMessage
    : t(errorMessage || fallback, params);
};
